// Global theme (dark-first, owner decision 2026-07-05 "modern dark-first UI").
// One localStorage key — 'wv-theme', the same one the Reader has used since
// slice 1 — now owned here and applied as <html data-theme>, so every surface
// (app.css tokens, read.css's scoped skin) follows the same switch.

import { createContext, useContext, useEffect, useState } from 'react';

const THEME_KEY = 'wv-theme';
const ThemeContext = createContext({ theme: 'dark', toggle: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem(THEME_KEY) || 'dark');

  useEffect(() => {
    localStorage.setItem(THEME_KEY, theme);
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const toggle = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

  return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
